import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  root: {
    position: 'relative',
    display: 'inline-block',
  },
  rootFullWidth: {
    display: 'block',
    width: '100%',
  },
  buttonFullWidth: {
    width: '100%',
  },
  menuFullWidth: {
    width: '100%',
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 32,
    padding: `10px 10px 10px ${theme.other.spacing._16}px`,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 100,
    border: `0.5px solid ${theme.colors.gray2[1]}`,
    background: theme.white,
    fontWeight: 700,
    fontSize: 14,
    // The label is a single line - the trigger sizes to it rather than wrapping
    // when it's squeezed by a sibling.
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    gap: theme.other.spacing._2,
    position: 'relative',
    transition: 'all 0.2s',
  },
  buttonInverted: {
    background: theme.colors.gray2[6],
    borderColor: theme.colors.gray2[6],
    color: theme.white,
    '& svg': {
      color: theme.white,
    },
  },
  menu: {
    position: 'absolute',
    left: 0,
    top: 44,
    width: 172,
    padding: theme.other.spacing._8,
    borderRadius: theme.other.spacing._8,
    background: theme.white,
    boxShadow: '0px 8px 40px 0px rgba(0,0,0,0.10)',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._8,
    zIndex: 100,
  },
  menuExpanded: {
    width: 'fit-content',
    minWidth: 172,
    maxWidth: 'none',
  },
  option: {
    display: 'flex',
    alignItems: 'center',
    height: theme.other.spacing._32,
    // Keeps rows at full height when the menu is capped and scrolling.
    flexShrink: 0,
    padding: `0 ${theme.other.spacing._12}px`,
    borderRadius: theme.other.spacing._8,
    cursor: 'pointer',
    color: theme.colors.gray2[6],
    background: 'transparent',
    width: '100%',
    '&:hover': {
      background: theme.colors.gray2[1],
    },
    '& .mantine-Radio-radio': {
      background: theme.white,
      borderColor: theme.colors.gray2[6],
      borderWidth: 2,
      width: theme.other.layout.paddingMd,
      height: theme.other.layout.paddingMd,
      minWidth: theme.other.layout.paddingMd,
      minHeight: theme.other.layout.paddingMd,
      boxSizing: 'border-box',
      position: 'relative',
    },
    '& .mantine-Radio-inner': {
      background: 'transparent',
      position: 'relative',
      width: theme.other.layout.paddingMd,
      height: theme.other.layout.paddingMd,
      minWidth: theme.other.layout.paddingMd,
      minHeight: theme.other.layout.paddingMd,
    },
    '& .mantine-Radio-icon': {
      display: 'none',
    },
    '& .mantine-Radio-radio:checked + .mantine-Radio-inner .mantine-Radio-icon': {
      display: 'block',
      background: theme.colors.gray2[1],
      borderRadius: '50%',
      width: theme.other.spacing._12,
      height: theme.other.spacing._12,
      position: 'absolute',
      top: theme.other.spacing._4,
      left: theme.other.spacing._4,
      right: theme.other.spacing._4,
      bottom: theme.other.spacing._4,
      margin: 'auto',
      boxShadow: 'none',
    },
    '& .mantine-Radio-inner svg': {
      display: 'none',
    },
    '& .mantine-Radio-radio:checked': {
      borderColor: theme.colors.gray2[6],
    },
  },
  selected: {
    background: theme.colors.gray2[0],
    color: 'inherit',
  },
  focused: {
    background: theme.colors.gray2[1],
    outline: `2px solid ${theme.colors.gray2[3]}`,
    outlineOffset: -2,
  },
  chevron: {
    marginLeft: theme.other.spacing._8,
    display: 'flex',
    alignItems: 'center',
    transition: 'transform 0.2s',
  },
  chevronOpen: {
    transform: 'rotate(180deg)',
  },
  customRadio: {
    width: 16,
    height: 16,
    minWidth: 16,
    minHeight: 16,
    borderRadius: '50%',
    border: `1px solid ${theme.colors.gray2[3]}`,
    background: theme.white,
    marginRight: theme.other.spacing._8,
    boxSizing: 'border-box',
    display: 'inline-block',
    position: 'relative',
    transition: 'border-color 0.2s',
  },
  customRadioChecked: {
    borderColor: theme.colors.gray2[6],
    '::after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      left: '50%',
      top: '50%',
      width: theme.other.layout.paddingSm,
      height: theme.other.layout.paddingSm,
      borderRadius: '50%',
      background: theme.colors.gray2[6],
      transform: 'translate(-50%, -50%)',
    },
  },
  optionLabel: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '120px',
    minWidth: 0,
    flex: 1,
    display: 'block',
  },
  optionLabelExpanded: {
    whiteSpace: 'nowrap',
    overflow: 'visible',
    textOverflow: 'unset',
    maxWidth: 'none',
    display: 'block',
  },
}));

export default useStyles;
